import { Box } from 'components/ui';

export const Group = Box;
